import React from 'react';
import {Button, Upload} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import {UploadChangeParam, UploadProps} from 'antd/lib/upload';
import {UploadFile} from 'antd/lib/upload/interface';
import {useAxios} from '../Http/AxiosProvider';
import {AttachmentDto} from '../scaffold';
import {Config} from '../config';
export interface UploadAttachmentDto extends AttachmentDto {
  uid: string;
}
export default function UploadAttachment(props: {value: UploadAttachmentDto[]; onChange: (v: UploadAttachmentDto[]) => any}) {
  const axios = useAxios();
  const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
    const newList: UploadAttachmentDto[] = info.fileList.map(file => {
      return {
        uid: file.uid,
        name: file.name,
        path: file.response ? file.response.path : file.url?.replace(Config.ossPrefix + '/', ''),
      };
    });
    props.onChange(newList);
  };

  return (
    <Upload
      name="file"
      action={axios.axiosConfig.baseURL + '/Article/UploadFile'}
      multiple={false}
      fileList={props.value.map((file, index) => ({
        uid: file.uid,
        name: file.name || '',
        status: file.path ? 'done' : 'uploading',
        url: file.path ? Config.ossPrefix + '/' + file.path : '',
        size: 0,
        type: '',
      }))}
      onChange={handleChange}>
      <Button icon={<UploadOutlined />}>点击上传附件</Button>
    </Upload>
  );
}
